module.exports = __webpack_public_path__ + "static/hero-mobile-ba3aed6dcf802fbb87bd58c072438b4e.jpg";